// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"18":"Developers","64":"BigCommerce","207":"Apps","255":"PaidMedia","288":"Portfolio","337":"Contact","765":"Pagespeed","781":"CaseStudy","896":"Client","910":"Magento","966":"ShopifyPlus"}[chunkId] || chunkId) + ".js";
};